import React, { useState } from "react";
import axios from "axios";
import * as Icons from "lucide-react";
import { toast } from "sonner";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { PageHero, Section, FadeIn } from "@/components/Layout";
import { SHOP_CATEGORIES } from "@/data/site";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

const Merchandise = () => {
  const [email, setEmail] = useState("");
  const [loading, setLoading] = useState(false);
  const [done, setDone] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    if (!email) return;
    setLoading(true);
    try {
      await axios.post(`${API}/newsletter`, { email });
      setDone(true);
      setEmail("");
      toast.success("You're on the list! We'll let you know when merchandise is available.");
    } catch (err) {
      toast.error("Please enter a valid email address.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div data-testid="merchandise-page">
      <PageHero
        eyebrow="Merchandise"
        title="Pet Essentials — Coming Soon"
        subtitle="We're getting ready to offer useful and affordable pet accessories. Check back soon!"
      />

      <Section className="py-16 sm:py-20">
        <FadeIn className="max-w-2xl mx-auto text-center">
          <div className="w-20 h-20 rounded-full bg-primary/12 flex items-center justify-center mx-auto mb-6">
            <Icons.ShoppingBag className="w-10 h-10 text-primary" />
          </div>
          <h2 className="font-heading text-3xl sm:text-4xl font-semibold text-foreground">Sales are on the way</h2>
          <p data-testid="merchandise-placeholder" className="mt-5 text-lg text-muted-foreground leading-relaxed">
            Our merchandise store isn't open just yet. Soon you'll be able to shop hand-picked pet essentials — toys,
            grooming tools, travel bowls, and more. In the meantime, reach out any time about pet care.
          </p>
        </FadeIn>

        <FadeIn>
          <div className="mt-14 flex flex-wrap gap-3 justify-center max-w-3xl mx-auto">
            {SHOP_CATEGORIES.map((cat) => (
              <span key={cat.name} data-testid="merchandise-category" className="rounded-full bg-accent text-foreground text-sm font-medium px-4 py-2">
                {cat.name}
              </span>
            ))}
          </div>
        </FadeIn>

        <FadeIn>
          <div className="mt-14 max-w-2xl mx-auto rounded-3xl bg-primary text-primary-foreground p-8 sm:p-12 text-center">
            <Icons.Bell className="w-9 h-9 mx-auto mb-4 opacity-80" />
            <h3 className="font-heading text-2xl sm:text-3xl font-semibold">Join the list to hear when merchandise is available.</h3>
            {done ? (
              <p data-testid="newsletter-success" className="mt-6 text-primary-foreground/90 text-lg">Thanks! We'll be in touch when we launch. 🐾</p>
            ) : (
              <form onSubmit={submit} className="mt-6 flex flex-col sm:flex-row gap-3 max-w-md mx-auto">
                <Input type="email" required data-testid="newsletter-email-input" value={email} onChange={(e) => setEmail(e.target.value)}
                  placeholder="your@email.com" className="rounded-full bg-white text-foreground border-0 px-6 h-12 flex-1" />
                <Button type="submit" disabled={loading} variant="secondary" data-testid="newsletter-submit" className="rounded-full h-12 px-8">
                  {loading ? "Joining…" : "Notify me"}
                </Button>
              </form>
            )}
          </div>
        </FadeIn>
      </Section>
    </div>
  );
};

export default Merchandise;
